<template>
  <div class="ccgd-row">
    <div class="ccgd-row-main">
      <div class="ccgd-row-title">
        <div class="ccgd-row-primary">{{ safeTitle(item) || item.name || "Item" }}</div>
        <div class="ccgd-badge">Item</div>
      </div>
    </div>

    <div class="ccgd-row-actions" @click.stop>
      <slot name="actionsCell" />
    </div>
  </div>
</template>

<script>
export default {
  name: "FallbackCard",
  props: { item: { type: Object, required: true } },
  methods: {
    safeTitle(item) {
      if (!item) return "";
      const t = item.title || item.name || "";
      if (typeof t !== "string") return "";
      const looksLikeAge = /^\s*\d+\s*(day|days)\s*$/i.test(t);
      if (looksLikeAge) {
        return item.taskname || item.tasktitle || "Task";
      }
      return t;
    }
  }
};
</script>
